module.exports = __webpack_public_path__ + "img/small-16.0a9eabf8.jpg";